import { Component } from '@angular/core';
import { CtrBaseComponent } from '../ctr-base.component';

@Component({
    ...CtrBaseComponent.metaData,
    selector: 'app-ctr-bank-detail',
    templateUrl: './ctr-bank-detail.component.html',
    styleUrls: ['../ctr-base.component.scss'],
    standalone: false
})
export class CtrBankDetailComponent extends CtrBaseComponent {
}
